import { useLocation } from 'react-router-dom';
import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';

import { text } from '../text';
import { hooks } from '../hooks';
import { utils } from '../utils';
import { theme } from '../constants';
import { components } from '../components';

export const Onboarding2: React.FC = () => {
    const { pathname } = useLocation();
    const navigate = hooks.useNavigate();

    const buttons = [
        {
            title: 'Continue with Mobile',
            path: '/onbording3',
        },
        {
            title: 'Continue with Google',
            path: '/onbording3',
        },
    ];

    const renderTitle = (): JSX.Element => {
        return (
            <div className='container'>
                <p className='heading'> Find your Happy Place</p>
                {/* <text.H2
                    style={{
                        textTransform: 'capitalize',
                        color: "#7065F0",
                        lineHeight: 1,

                    }}
                >
                    Find your Happy Place
                </text.H2> */}
            </div>
        );
    };

    const renderDescription = (): JSX.Element => {
        return (
            <div className='container'>
                <text.T16
                    style={{
                        lineHeight: 1.2,
                        textAlign: 'center',
                        whiteSpace: 'pre-line',
                        marginBottom: 10,
                    }}
                >
                    To get started,please verify your mobile number
                </text.T16>
            </div>
        );
    };
    const renderDescription1 = (): JSX.Element => {
        return (
            <div className='container'>
                {/* <text.T14
                    style={{
                        lineHeight: 1,
                        whiteSpace: 'pre-line',
                        marginBottom: 10,
                    }}
                >
                    By submitting you agree to our <span style={{ color: '#7065F0' }}>Terms & Conditions</span>  & <span style={{ color: '#7065F0' }}> Privacy Policy</span>
                </text.T14> */}
                <text.T14
                    style={{
                        lineHeight: 1,
                        whiteSpace: 'pre-line',
                        marginBottom: 10,
                    }}
                >
                    By submitting you agree to our <span style={{ color: '#7065F0' }}>Terms & Conditions</span>  & <span style={{ color: '#7065F0' }}> Privacy Policy</span>
                </text.T14>
            </div>
        );
    };
    const renderButtons = (): JSX.Element => (
        <div
            style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                padding: '36px 16px 36px 16px',
                background: ' #FFFFFF',
                backdropFilter: 'blur(4px)',
                boxSizing: 'border-box',
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
            }}
        >
            <div
                className='button-container'
                style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
            >
                {renderTitle()}
                {renderDescription()}

                {buttons.map((btn, index) => (

                    <div id='onbording1' onClick={() => navigate(btn.path)} style={{
                        backgroundColor: index === 0 ? '#7065F0' : '#fff',
                        color: index === 0 ? '#fff' : '#7065F0'
                    }}>
                        {btn.title}
                    </div>



                    // <components.Button
                    //     key={index}
                    //     style={{
                    //         backgroundColor: index === 0 ? '#7065F0' : '#fff',
                    //         color: index === 0 ? '#fff' : '#7065F0',
                    //         border: '1px solid #7065F0',
                    //     }}
                    //     title={btn.title}
                    //     onClick={() => navigate(btn.path)}
                    // />
                ))}
                {renderDescription1()}
            </div>
        </div>
    );
    return (
        <div style={{ position: 'relative', minHeight: '100vh' }}>
            <div style={{ width: '100%', height: '100vh', overflow: 'hidden', position: 'relative' }}>
                <img
                    src={require('../assets/nestfin/mainb1.jpg')}
                    alt='Onboarding Visual'
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                {renderButtons()}
            </div>
        </div>
    );
};
